angular.module('bookAndPay').controller('SampleCompleteCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "cart", function($scope, $rootScope, $state, $stateParams, cart) {
  $scope.cart = cart;
  $scope.currency = $rootScope.data.currency;
  $scope.cart.sample_complete = true;
  $scope.cart.event_selected = cart.cart_type !== 'payment_only_cart';
  $scope.cart.invoice_number = '1111-12345678';
  $scope.cart.event_start_at = moment();
  $scope.cart.payment_method_description = "Credit card ending in 1234";
  $scope.cart.event_instructor_name = 'Annie Anderson';
  $scope.cart.event_location_name = 'Example Room';
  $scope.cart.event_name = 'Test Event';
  $scope.cart.payment_amount = '50.0';
  $scope.cart.payment_processed_at_human = moment().format('H:mm A, dddd D MMMM');
  $scope.cartType = cart.cart_type === 'payment_only_cart' ? 'po' : void 0;
  return $scope.displayTime = function() {
    return moment(cart.event_start_at).format('ddd, D MMM [at] h:mm');
  };
}]);
